export const errorHandler = (error) => {
  if (error.response) {
    return error.response.data.error_description;
  } else if (error.request) {
    return error.error;
  } else {
    return 'Something went wrong';
  }
};
